import { Calculator, ShieldCheck, ShieldPlus, Store, UserCog, Users } from 'lucide-react';
export {
  DEFAULT_ACCOUNTANT_SEAWEED_ACCESS_TABS,
  SEAWEED_ADMIN_TAB_OPTIONS,
} from '../../../constants/seaweedAccessTabs';

export const ADMIN_USER_TYPE = 1;
export const STAFF_USER_TYPE = 2;
export const DEFAULT_ROLE_NAME = 'staff';

export const ROLE_OPTIONS = [
  {
    value: 'admin',
    label: 'Admin',
    description: 'Can open and manage the selected business portal with full admin access.',
    access: ['Open admin portal', 'Manage business records', 'Full business access'],
    icon: ShieldPlus,
    userType: ADMIN_USER_TYPE,
  },
  {
    value: 'admin-custom',
    label: 'Admin (custom)',
    description: 'Admin-level business account intended for custom portal access and workflows.',
    access: ['Open admin portal', 'Use custom admin access', 'Business-wide access'],
    icon: UserCog,
    userType: ADMIN_USER_TYPE,
  },
  {
    value: 'manager',
    label: 'Manager',
    description: 'Can oversee branch operations, staff coordination, and day-to-day activity.',
    access: ['View branch activity', 'Manage assigned staff', 'Handle operations'],
    icon: ShieldCheck,
    userType: STAFF_USER_TYPE,
  },
  {
    value: 'cashier',
    label: 'Cashier',
    description: 'Can handle cashier-side work and daily transaction processing.',
    access: ['Process transactions', 'Handle customer payments', 'View own branch work'],
    icon: Store,
    userType: STAFF_USER_TYPE,
  },
  {
    value: 'accountant',
    label: 'Accountant',
    description: 'Staff-login account with custom Seaweeds admin tab access.',
    access: ['Login through staff portal', 'Open selected Seaweeds tabs', 'Review permitted records'],
    icon: Calculator,
    userType: STAFF_USER_TYPE,
  },
  {
    value: 'staff',
    label: 'Staff',
    description: 'General staff account for operational work under an assigned branch.',
    access: ['Use assigned workflow', 'View branch-specific tasks', 'Limited access only'],
    icon: Users,
    userType: STAFF_USER_TYPE,
  },
];

export function getRoleOption(roleName, userType) {
  const role = ROLE_OPTIONS.find((item) => item.value === roleName);

  if (role) {
    return role;
  }

  if (userType === ADMIN_USER_TYPE) {
    return ROLE_OPTIONS.find((item) => item.value === 'admin');
  }

  return ROLE_OPTIONS.find((item) => item.value === DEFAULT_ROLE_NAME);
}

export function getUserTypeForRole(roleName) {
  return getRoleOption(roleName)?.userType || STAFF_USER_TYPE;
}
